<template>
  <div class="registration-page">
   <!-- 탭 헤더 -->
    <div class="tab-header">
      <button    v-for="tab in tabs" :key="tab.id"  :class="['tab-btn', { active: activeTab === tab.id }]"   @click="changeTab(tab.id)"  >
            {{ tab.label }}
      </button>
    </div>
     <!-- 탭 컨텐츠 -->
    <div class="tab-content">
       <!-- 홈약관 -->
      <div v-if="activeTab === 'home'" class="registration-page-container">
          <div class="section">
            <div class="section-header">
              <h3>이용약관</h3>
            </div>

            <div class="section-body">
              <dl class="field-group vertical">
                <!--- agree2 -->
                <dt class="field-label wfull">
                  <h4 role="heading" tabindex="0">
                    고유식별 정보 수집, 이용 동의<em class="primary-text"> (필수동의)</em>
                  </h4>
                </dt>
                <dd class="field-control wfull">
                  <div class="field-control-sub text-detail scrollable">
                    <p
                      role="region"
                      tabindex="0"
                      class="td-term"
                      v-html="requiredForOnlyOneInformation"
                    />
                  </div>
                </dd>
              </dl>

              <dl class="field-group vertical">
                <!--- agree7 -->
                <dt class="field-label wfull">
                  <h4 role="heading" tabindex="0">
                    개인정보 수집 이용동의<em
                      class="primary-text"
                    >
                      (필수동의)</em
                    >
                  </h4>
                </dt>
                <dd class="field-control wfull">
                  <div class="field-control-sub text-detail scrollable">
                    <p
                      role="region"
                      tabindex="0"
                      class="td-term"
                      v-html="requiredForPersonalInformation"
                    />
                  </div>
                </dd>
              </dl>

              <dl class="field-group vertical">
                <!--- agree11 -->
                <dt class="field-label wfull">
                  <h4 role="heading" tabindex="0">
                    개인위치 정보 수집,이용동의<em class="primary-text">
                      (필수동의)</em
                    >
                  </h4>
                </dt>
                <dd class="field-control wfull">
                  <div class="field-control-sub text-detail scrollable">
                    <p
                      role="region"
                      tabindex="0"
                      class="td-term"
                      v-html="requiredForPersonalLocationInformation"
                    />
                  </div>
                </dd>
              </dl>
              <dl class="field-group vertical">

                <dt class="field-label wfull">
                  <h4 role="heading" tabindex="0">
                    개인정보 제3자 제공 동의<em class="primary-text">
                      (필수동의)</em
                    >
                  </h4>
                </dt>
                <dd class="field-control wfull">
                  <div class="field-control-sub text-detail scrollable">
                    <p
                      role="region"
                      tabindex="0"
                      class="td-term"
                      v-html="requiredForServiceProviding"
                    />
                  </div>
                </dd>
              </dl>
              <!--국외이전동의 2026.02.02 추가-->
              <dl class="field-group vertical">
                <dt class="field-label wfull">
                  <h4 role="heading" tabindex="0">
                    개인정보 국외이전 동의<em class="primary-text">
                      (필수동의)</em
                    >
                  </h4>
                </dt>
                <dd class="field-control wfull">
                  <div class="field-control-sub text-detail scrollable">
                    <p
                      role="region"
                      tabindex="0"
                      class="td-term"
                      v-html="requiredForCrossBordertransferInformation"
                    />
                  </div>
                </dd>
              </dl>
              <dl class="field-group vertical">

                <dt class="field-label wfull">
                  <h4 role="heading" tabindex="0">
                    개인신용정보 조회 동의<em class="primary-text">
                      (필수동의)</em
                    >
                  </h4>
                </dt>
                <dd class="field-control wfull">
                  <div class="field-control-sub text-detail scrollable">
                    <p
                      role="region"
                      tabindex="0"
                      class="td-term"
                      v-html="requiredForCreditInformation"
                    />
                  </div>
                </dd>
              </dl>

              <dl class="field-group vertical">
                <!--- agree8 -->
                <dt class="field-label wfull">
                  <h4 role="heading" tabindex="0">
                    고객 혜택정보 제공을 위한 정보 수집 ·이용 동의
                  </h4>
                </dt>
                <dd class="field-control wfull">
                  <div class="field-control-sub text-detail scrollable">
                    <p
                      role="region"
                      tabindex="0"
                      class="td-term"
                      v-html="optionalMarketingOffer"
                    />
                  </div>
                </dd>
              </dl>

              <dl class="field-group vertical">
                <!--- agree10 -->
                <dt class="field-label wfull">
                  <h4 role="heading" tabindex="0">
                    혜택정보 · 광고 수신 동의
                  </h4>
                </dt>
                <dd class="field-control wfull">
                  <div class="field-control-sub text-detail scrollable">
                    <p
                      role="region"
                      tabindex="0"
                      class="td-term"
                      v-html="optionalMarketingOfferPersonal"
                    />
                  </div>
                </dd>
              </dl>
            </div>
         
        </div>
      </div>
      <!-- 소호약관 -->
      <div v-else-if="activeTab === 'soho'" class="registration-page-container">
          <div class="section">
            <div class="section-header">
              <h3>이용약관</h3>
            </div>

            <div class="section-body">
              <dl class="field-group vertical">
                <!--- agree2 -->
                <dt class="field-label wfull">
                  <h4 role="heading" tabindex="0">
                    고유식별 정보 수집, 이용 동의<em class="primary-text"> (필수동의)</em>
                  </h4>
                </dt>
                <dd class="field-control wfull">
                  <div class="field-control-sub text-detail scrollable">
                    <p
                      role="region"
                      tabindex="0"
                      class="td-term"
                      v-html="requiredForOnlyOneInformation"
                    />
                  </div>
                </dd>
              </dl>

              <dl class="field-group vertical">
                <!--- agree7 -->
                <dt class="field-label wfull">
                  <h4 role="heading" tabindex="0">
                    개인정보 수집 이용동의<em
                      class="primary-text"
                    >
                      (필수동의)</em
                    >
                  </h4>
                </dt>
                <dd class="field-control wfull">
                  <div class="field-control-sub text-detail scrollable">
                    <p
                      role="region"
                      tabindex="0"
                      class="td-term"
                      v-html="requiredForPersonalInformation"
                    />
                  </div>
                </dd>
              </dl>

              <dl class="field-group vertical">
                <!--- agree11 -->
                <dt class="field-label wfull">
                  <h4 role="heading" tabindex="0">
                    개인위치 정보 수집,이용동의<em class="primary-text">
                      (필수동의)</em
                    >
                  </h4>
                </dt>
                <dd class="field-control wfull">
                  <div class="field-control-sub text-detail scrollable">
                    <p
                      role="region"
                      tabindex="0"
                      class="td-term"
                      v-html="requiredForPersonalLocationInformation"
                    />
                  </div>
                </dd>
              </dl>
              <dl class="field-group vertical">

                <dt class="field-label wfull">
                  <h4 role="heading" tabindex="0">
                    개인정보 제3자 제공 동의<em class="primary-text">
                      (필수동의)</em
                    >
                  </h4>
                </dt>
                <dd class="field-control wfull">
                  <div class="field-control-sub text-detail scrollable">
                    <p
                      role="region"
                      tabindex="0"
                      class="td-term"
                      v-html="requiredForServiceProviding"
                    />
                  </div>
                </dd>
              </dl>
              <dl class="field-group vertical">

                <dt class="field-label wfull">
                  <h4 role="heading" tabindex="0">
                    개인신용정보 조회 동의<em class="primary-text">
                      (필수동의)</em
                    >
                  </h4>
                </dt>
                <dd class="field-control wfull">
                  <div class="field-control-sub text-detail scrollable">
                    <p
                      role="region"
                      tabindex="0"
                      class="td-term"
                      v-html="requiredForCreditInformation"
                    />
                  </div>
                </dd>
              </dl>

              <dl class="field-group vertical">
                <!--- agree8 -->
                <dt class="field-label wfull">
                  <h4 role="heading" tabindex="0">
                    고객 혜택정보 제공을 위한 정보 수집 ·이용 동의
                  </h4>
                </dt>
                <dd class="field-control wfull">
                  <div class="field-control-sub text-detail scrollable">
                    <p
                      role="region"
                      tabindex="0"
                      class="td-term"
                      v-html="optionalMarketingOffer"
                    />
                  </div>
                </dd>
              </dl>

              <dl class="field-group vertical">
                <!--- agree10 -->
                <dt class="field-label wfull">
                  <h4 role="heading" tabindex="0">
                    혜택정보 · 광고 수신 동의
                  </h4>
                </dt>
                <dd class="field-control wfull">
                  <div class="field-control-sub text-detail scrollable">
                    <p
                      role="region"
                      tabindex="0"
                      class="td-term"
                      v-html="optionalMarketingOfferPersonal"
                    />
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        
      </div>
    </div>
   </div>
</template>

<script>

export default {
  name: 'OnsaleHomeTerms',

  props: {},

  data() {
    return {
      activeTab: 'home',
      tabs: [
        { id: 'home', label: '홈' },
        { id: 'soho', label: '소호' },
      ]
    }
  },

  computed: {
    reqTermConditionList() {
      return this.termConditionList.filter(i => i.req)
    },
    optTermConditionList() {
      return this.termConditionList.filter(i => !i.req)
    },

    requiredForOnlyOneInformation() {
      return require('html-loader!~/html/appl/agree1_home.html')
    },
    requiredForPersonalInformation() {
      return require('html-loader!~/html/appl/agree2_home.html' )
    },
    requiredForPersonalLocationInformation(){
      //이용약관 개인정보위치 수집동의 분리 2020.06.08 장희정 추가
      return require('html-loader!~/html/appl/agree_personal_location.html')
    },
    requiredForServiceProviding() {
      return require('html-loader!~/html/appl/agree7_home.html')
    },
    requiredForCrossBordertransferInformation(){
      //이용약관 국외이전동의 2026.02.02 장희정 추가
      return require('html-loader!~/html/appl/agree_crossbordertransfer_home.html')
    },
    requiredForCreditInformation() {
      return require('html-loader!~/html/appl/agree5_hmcredit.html' )
    },
 
    optionalMarketingOffer() {
      //  고객 혜택정보/광고 정보 제공을 위한 동의(선택동의) => 24.05.02 고객 혜택정보 제공을 위한 정보 수집 ·이용 동의 
      return require('html-loader!~/html/appl/agree8_home.html')
    },
    optionalMarketingOfferWay() {
      //  광고전송동의(선택동의)
      return require('html-loader!~/html/appl/agree9.html')
    },
    optionalMarketingOfferPersonal() {
      //  고객 혜택정보/광고 정보 제공을 위한 개인정보 처리위탁 동의(선택동의) => 24.05.02 혜택정보 · 광고 수신 동의
      return require('html-loader!~/html/appl/agree10_home.html')
    },
    optionalMarketingOfferPersonalTrst() {
      //  24.05.02 고객 혜택정보/광고 정보 제공을 위한 개인정보 처리위탁 안내
      return require('html-loader!~/html/appl/agree16.html')
    }
  },

  methods: {
    changeTab(tabId) {
      this.activeTab = tabId
    }
  }
}
</script>

<style scoped>
.tabs-container {
  width: 100%;
}

.tab-header {
  display: flex;
  border-bottom: 2px solid #d6d6d6;
}

.tab-btn {
  padding: 10px 20px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  color: #5b5b5b;
  position: relative;
  transition: color 0.2s;
}

.tab-btn:hover {
  color: #5b5b5b;
}

.tab-btn.active {
  color: #e50689;
  font-weight: 600;
}

.tab-btn.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #e50689;
}

.tab-content {
  padding: 5px 0;
}
</style>
